// extracted by mini-css-extract-plugin
export default {"policyTexts":"footerpages_policyTexts__jSLDb","policyTextContaier":"footerpages_policyTextContaier__RLKIv","marginforP":"footerpages_marginforP__vtbKI"};